import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { LWApiPublicMarketCartDetailsResultRawI } from '@liquidweb-dev/club-sauce/public/market/cart/index.raw';
import type { LWApiPublicMarketCartItemAddParamsRawI } from '@liquidweb-dev/club-sauce/public/market/cart/item.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import { useDispatch } from 'react-redux';
import { merge } from 'lodash';
import { cartDetailsActions } from 'modules/api/market/cart/detailsModule';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import { MARKET_CART_DETAILS_QUERY_KEY } from '../useDetails';

const useCartItemAdd = () => {
	const snackbarError = useSnackbarError();
	const queryClient = useQueryClient();
	const dispatch = useDispatch();

	return useMutation<
		LWApiPublicMarketCartDetailsResultRawI,
		ApiErrorI,
		LWApiPublicMarketCartItemAddParamsRawI
	>({
		mutationFn: (params) => api.market.cart.item.apiRaw.add(params),
		onSuccess: (data) => {
			queryClient.setQueriesData<LWApiPublicMarketCartDetailsResultRawI>(
				{
					queryKey: [
						MARKET_CART_DETAILS_QUERY_KEY,
						{
							uuid: data.uuid,
						},
					],
				},
				(oldData) => merge(oldData ?? {}, data),
			);

			// Invalidate old redux cart API data
			dispatch(cartDetailsActions.invalidate({ uuid: data.uuid }));
		},
		onError: snackbarError,
	});
};

export default useCartItemAdd;
